import { Doughnut, mixins } from 'vue-chartjs'
import DefaultOptions from '../DefaultOptions'

export default Doughnut.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],

  data () {
    return {
      defaultOptions: {

      }
    }
  },

  mounted () {
    let options = Object.assign({}, DefaultOptions, this.defaultOptions, this.options)
    this.renderChart(this.chartData, options)
  }
})



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-chart/chart-types/DonutChart.js